import type { ApolloError } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';

import { convertUserGender } from '@xing-com/crate-social-utils';
import type { FacepileActorProps } from '@xing-com/facepile';
import type { FallbackImageType } from '@xing-com/super-ellipse';

import type { SocialProofQuery } from '../graphql';
import { SocialProofDocument } from '../graphql';

type Actor = {
  profileName: string;
  type: FallbackImageType;
  id: string;
  src: string;
};
export const parseDataToActor = (
  data: SocialProofQuery | undefined
): Array<Actor | undefined> => {
  if (data?.viewer?.socialProof?.collection) {
    return data.viewer.socialProof.collection.map((item) => {
      const user = item?.user;
      if (!user) return;
      const src = user?.profileImage?.[0]?.url || '';
      return {
        profileName: user.displayName,
        type: convertUserGender(user?.gender),
        id: user.id,
        src,
      };
    });
  } else {
    return [];
  }
};

type UseSocialProof = {
  actors: FacepileActorProps[];
  isLoading: boolean;
  hasError: ApolloError | undefined;
  fetchSocialProof: () => void;
};

export const useSocialProof = (urn = ''): UseSocialProof => {
  const [fetchSocialProof, { data, loading, error }] = useLazyQuery(
    SocialProofDocument,
    {
      variables: { urn },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
    }
  );

  return {
    actors: parseDataToActor(data) as FacepileActorProps[],
    isLoading: loading,
    hasError: error,
    fetchSocialProof,
  };
};
